import { useEffect, useState } from "react";

export default function SplashScreen({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => onFinish && onFinish(), 600);
          }, 300);
          return 100;
        }
        return prev + 2;
      });
    }, 40);
    return () => clearInterval(interval);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center overflow-hidden z-50 transition-opacity duration-500 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
      style={{ backgroundColor: "#060d1f" }}
    >
      {/* Animated SVG waves at bottom */}
      <svg
        className="absolute bottom-0 left-0 w-full h-2/5 pointer-events-none"
        viewBox="0 0 400 300"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="wave1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1a56db" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#7e3af2" stopOpacity="0.6" />
          </linearGradient>
          <linearGradient id="wave2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0.3" />
          </linearGradient>
        </defs>
        <path d="M-50 200 Q100 120 250 180 T550 150 L550 300 L-50 300 Z" fill="url(#wave1)">
          <animateTransform attributeName="transform" type="translate" values="0,0;-50,20;0,0" dur="6s" repeatCount="indefinite" />
        </path>
        <path d="M-50 230 Q150 160 300 210 T600 180 L600 300 L-50 300 Z" fill="url(#wave2)">
          <animateTransform attributeName="transform" type="translate" values="0,0;40,-15;0,0" dur="8s" repeatCount="indefinite" />
        </path>
      </svg>

      {/* Main content */}
      <div className="flex flex-col items-center gap-4 z-10">

        {/* Logo with pulse animation */}
        <div className="w-32 h-32 flex items-center justify-center animate-pulse">
          <img
            src="/logo512.png"
            alt="EduPulseAI"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Brand name */}
        <div className="flex items-baseline text-4xl font-bold tracking-tight mt-2">
          <span className="text-white">edu</span>
          <span className="text-blue-400">pulse</span>
          <span className="text-violet-400">ai</span>
        </div>

        {/* Tagline */}
        <p className="text-xs tracking-widest font-medium text-slate-400">
          LEARN SMART. GROW FAST.
        </p>
      </div>

      {/* Loading bar at bottom */}
      <div className="absolute bottom-14 flex flex-col items-center gap-2 w-44 z-10">
        <p className="text-sm text-slate-400">Loading...</p>
        <div className="w-full h-1 rounded-full overflow-hidden bg-slate-800">
          <div
            className="h-full rounded-full transition-all duration-75"
            style={{
              width: `${progress}%`,
              background: "linear-gradient(90deg, #1a56db, #7e3af2)",
            }}
          />
        </div>
      </div>
    </div>
  );
}